export default class Client {
  static from (localStorageClient) {
    try {
      var currentClient = JSON.parse(localStorageClient)
      return new Client(currentClient)
    } catch (e) {
      return null
    }
  }

  constructor ({ id, name, analytics_id, domain }) { // eslint-disable-line camelcase
    this.id = id
    this.name = name
    this.analyticsId = analytics_id
    this.domain = domain
    this.current = false
  }
}
